var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"text-center my-2",attrs:{"color":"white"}},[_c('v-img',{staticClass:"mx-auto",attrs:{"width":"245","src":_vm.noData,"alt":"no-transaction"}}),_c('p',{staticClass:"mt-4 text-h6"},[_vm._v("No transaction yet")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }